import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "component-variable__values__value"
};
const _hoisted_2 = { key: 1 };
import { computed, ref, toRef } from "vue";
import ComponentVariableVariantLabel from "./ComponentVariableVariantLabel.vue";
import { useComponentVariableMutable } from "src/shared/store/component-mutable/composables/useComponentVariableMutable";
import { useDefaultVariant } from "src/shared/store/component-built/composables/useDefaultVariant";
import { useBuiltComponentVariable } from "src/shared/store/component-built/composables";
import { getCampaignComponentVariableDefaultValue } from "src/shared/store/campaign-component/variable/model/campaign-component-variable-value-defaults";
import { useDestructuredEvaluatableValue } from "src/shared/evaluatable";
import ComponentVariableRawValue from "./ComponentVariableRawValue.vue";
import ComponentVariableBuiltValue from "./ComponentVariableBuiltValue.vue";
import ComponentVariablePreviewValue from "./ComponentVariablePreviewValue.vue";
import { useResolvedWorkingVariant } from "./useResolvedWorkingVariant";
import { useRawVariantValue } from "./useRawVariantValue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableValue',
    props: {
        componentMutableKey: {},
        variableName: {},
        variant: {},
        variantDisplayMode: {}
    },
    setup(__props) {
        const props = __props;
        const { componentVariableMutable } = useComponentVariableMutable(toRef(props, "componentMutableKey"), toRef(props, "variableName"));
        const componentId = computed(() => {
            var _a;
            return (_a = componentVariableMutable.value) === null || _a === void 0 ? void 0 : _a.getComponentId();
        });
        const { defaultVariant } = useDefaultVariant(componentId);
        const { builtComponentVariable } = useBuiltComponentVariable(componentId, toRef(props, "variableName"));
        const defaultProvidedValue = computed(() => {
            if (!componentVariableMutable.value) {
                return undefined;
            }
            return getCampaignComponentVariableDefaultValue(componentVariableMutable.value.getType());
        });
        const { resolvedWorkingVariant } = useResolvedWorkingVariant(toRef(props, "variant"), defaultVariant, componentVariableMutable);
        const { rawVariantValue } = useRawVariantValue(() => props.variant, resolvedWorkingVariant, componentVariableMutable, () => props.variantDisplayMode);
        const canBeTranslated = computed(() => {
            var _a;
            return ((((_a = componentVariableMutable.value) === null || _a === void 0 ? void 0 : _a.isTranslatable()) &&
                componentVariableMutable.value.getType() === "STRING") ||
                false);
        });
        const showVariantLabel = computed(() => {
            return props.variantDisplayMode === "MULTI_VARIANT";
        });
        const variantAliased = computed(() => {
            if (!defaultVariant.value || !componentVariableMutable.value) {
                return null;
            }
            if (componentVariableMutable.value.hasVariant(props.variant)) {
                return props.variant;
            }
            else if (props.variant === defaultVariant.value) {
                return "default";
            }
            return props.variant;
        });
        const focus = () => {
            isFocused.value = true;
        };
        const isFocused = ref(false);
        const { isProvided, language } = useDestructuredEvaluatableValue(rawVariantValue);
        const isSourceParameter = computed(() => {
            var _a;
            return ((_a = builtComponentVariable.value) === null || _a === void 0 ? void 0 : _a.source) === "PARAMETER";
        });
        const isDirty = computed(() => {
            if (!resolvedWorkingVariant.value || !componentVariableMutable.value) {
                return false;
            }
            return (componentVariableMutable.value.isValueDirty(resolvedWorkingVariant.value) || false);
        });
        const displayMode = computed(() => {
            if (isSourceParameter.value) {
                return "BUILT";
            }
            if (!componentVariableMutable.value) {
                return "RAW";
            }
            if (componentVariableMutable.value.getType() === "IMAGE") {
                return "RAW";
            }
            if (componentVariableMutable.value.getType() === "FONT") {
                return "RAW";
            }
            if (componentVariableMutable.value.isHtml()) {
                return "RAW";
            }
            if (componentVariableMutable.value.isNew()) {
                return "RAW";
            }
            if (isProvided.value) {
                return "RAW";
            }
            if (isDirty.value || isFocused.value) {
                return "RAW";
            }
            if (componentVariableMutable.value.getType() === "STRING" &&
                language.value === "handlebars") {
                return "PREVIEW";
            }
            return "BUILT";
        });
        return (_ctx, _cache) => {
            return (_unref(builtComponentVariable) &&
                _unref(componentVariableMutable) &&
                _unref(defaultVariant) &&
                variantAliased.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (showVariantLabel.value)
                        ? (_openBlock(), _createBlock(ComponentVariableVariantLabel, {
                            key: 0,
                            value: _unref(rawVariantValue),
                            "component-id": componentId.value,
                            "variable-name": _ctx.variableName,
                            "component-mutable-key": _ctx.componentMutableKey,
                            displayName: _ctx.variableName,
                            variant: variantAliased.value,
                            defaultVariant: _unref(defaultVariant),
                            "variable-display-name": _ctx.variableName,
                            "can-be-translated": canBeTranslated.value,
                            hasVariant: _unref(componentVariableMutable).hasVariant(_ctx.variant),
                            onRemoveVariant: _cache[0] || (_cache[0] = ($event) => (_unref(componentVariableMutable).removeVariant(_ctx.variant))),
                            onAddVariant: _cache[1] || (_cache[1] = ($event) => (_unref(componentVariableMutable).addVariant(_ctx.variant))),
                            onAddTranslatedVariant: _cache[2] || (_cache[2] =
                                (translatedValue) => {
                                    var _a;
                                    (_a = _unref(componentVariableMutable)) === null || _a === void 0 ? void 0 : _a.setValue(_ctx.variant, translatedValue);
                                })
                        }, null, 8 /* PROPS */, ["value", "component-id", "variable-name", "component-mutable-key", "displayName", "variant", "defaultVariant", "variable-display-name", "can-be-translated", "hasVariant"]))
                        : _createCommentVNode("v-if", true),
                    (_unref(componentVariableMutable) && defaultProvidedValue.value !== undefined)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (displayMode.value === 'RAW')
                                ? (_openBlock(), _createBlock(ComponentVariableRawValue, {
                                    key: 0,
                                    "component-mutable-key": _ctx.componentMutableKey,
                                    "variable-name": _ctx.variableName,
                                    variant: _ctx.variant,
                                    "variant-display-mode": _ctx.variantDisplayMode,
                                    "is-focused": isFocused.value,
                                    "onUpdate:isFocused": _cache[3] || (_cache[3] = ($event) => ((isFocused).value = $event))
                                }, null, 8 /* PROPS */, ["component-mutable-key", "variable-name", "variant", "variant-display-mode", "is-focused"]))
                                : _createCommentVNode("v-if", true),
                            (displayMode.value === 'BUILT')
                                ? (_openBlock(), _createBlock(ComponentVariableBuiltValue, {
                                    key: 1,
                                    "component-mutable-key": _ctx.componentMutableKey,
                                    "variable-name": _ctx.variableName,
                                    variant: _ctx.variant,
                                    "variant-display-mode": _ctx.variantDisplayMode,
                                    onFocus: _cache[4] || (_cache[4] = ($event) => (focus()))
                                }, null, 8 /* PROPS */, ["component-mutable-key", "variable-name", "variant", "variant-display-mode"]))
                                : _createCommentVNode("v-if", true),
                            (displayMode.value === 'PREVIEW')
                                ? (_openBlock(), _createBlock(ComponentVariablePreviewValue, {
                                    key: 2,
                                    "component-mutable-key": _ctx.componentMutableKey,
                                    "variable-name": _ctx.variableName,
                                    variant: _ctx.variant,
                                    "variant-display-mode": _ctx.variantDisplayMode,
                                    onFocus: _cache[5] || (_cache[5] = ($event) => (focus()))
                                }, null, 8 /* PROPS */, ["component-mutable-key", "variable-name", "variant", "variant-display-mode"]))
                                : _createCommentVNode("v-if", true)
                        ]))
                        : _createCommentVNode("v-if", true)
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
